import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=12ab2d4a"
import script from "./Presets.vue?vue&type=script&lang=js"
export * from "./Presets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports